import Api from '../Api';

export interface GetApiCredentialsResult {
  isActive: boolean;
  apiKey: string;
  storeKey: string;
  createdAt: string;
  displaySecret: string;
  description: string;
  createdBy: string;
  lastModifiedAt: string;
  lastUsedAt: string;
  customerId: string;
}

class ApiCredentialsService extends Api {
  async getApiCredentials(authToken: string): Promise<GetApiCredentialsResult[]> {
    const { data } = await this.httpClient.get('/credentials', {
      headers: {
        Authorization: authToken,
      },
    });
    return data;
  }
}

export default ApiCredentialsService;
